import { render, staticRenderFns } from "./postDetail.vue?vue&type=template&id=72b1f350&"
import script from "./postDetail.vue?vue&type=script&lang=js&"
export * from "./postDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports